import RouterFactory from '@trax/classes/RouterFactory'

// Layout.
import AuthLayout from './layout/AuthLayout.vue';
import FullPageLayout from './layout/FullPageLayout.vue';
import SideMenuLayout from './layout/SideMenuLayout.vue';

// General Views.
import NotFoundPage from './pages/NotFoundPage.vue';
import UnauthorizedPage from './pages/UnauthorizedPage.vue';
import MaintenancePage from './pages/MaintenancePage.vue';
import ErrorPage from './pages/ErrorPage.vue';

// Auth Views.
import LoginPage from './pages/auth/LoginPage.vue';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage.vue';
import DefinePasswordPage from './pages/auth/DefinePasswordPage.vue';
import MyAccountPage from './pages/auth/MyAccountPage.vue';
import ChangePassword from './pages/auth/ChangePasswordPage.vue';
import PrivacyPage from './pages/PrivacyPage.vue';

// Account Views.
import AdminUsersPage from './pages/accounts/UsersPage.vue';
import AdminUserPage from './pages/accounts/UserPage.vue';
import AdminCohortsPage from './pages/accounts/CohortsPage.vue';
import AdminCohortPage from './pages/accounts/CohortPage.vue';
import AdminMetaCohortPage from './pages/accounts/MetaCohortPage.vue';
import AdminRolesPage from './pages/accounts/RolesPage.vue';
import AdminOwnersPage from './pages/accounts/OwnersPage.vue';
import AdminEntitiesPage from './pages/accounts/EntitiesPage.vue';

// Training Views.
import AdminCompetenciesPage from './pages/training/CompetenciesPage.vue';
import AdminCompetencyGridsPage from './pages/training/CompetencyGridsPage.vue';
import AdminGridPage from './pages/training/CompetencyGridPage.vue';
import AdminDegreesPage from './pages/training/DegreesPage.vue';
import AdminDegreePage from './pages/training/DegreePage.vue';
import AdminLogPage from './pages/training/LogPage.vue';
import AdminRegistrationsPage from './pages/training/RegistrationsPage.vue';

// Admin import views.
import AdminImportUsersPage from './pages/accounts/ImportUsersPage.vue';
import AdminImportCohortsPage from './pages/accounts/ImportCohortsPage.vue';

// Settings view.
import AdminSocratesExportPage from './pages/settings/SocratesExportPage.vue';

// Admin clear views.
import AdminClearUsersPage from './pages/accounts/ClearUsersPage.vue';
import AdminClearCohortsPage from './pages/accounts/ClearCohortsPage.vue';
import AdminClearCompetencyGridsPage from './pages/training/ClearCompetencyGridsPage.vue';
import AdminClearDegreesPage from './pages/training/ClearDegreesPage.vue';
import AdminClearRegistrationsPage from './pages/training/ClearRegistrationsPage.vue';

// Home Views.
import HomePage from './pages/HomePage.vue';
import DashboardHomePage from './pages/dashboard/HomePage.vue';
import DashboardLearnerHomePage from './pages/dashboard/LearnerHomePage.vue';
import DashboardInstructorWarningsPage from './pages/dashboard/InstructorWarningsPage.vue';
import OfflineDashboardPage from './pages/dashboard/OfflineDashboardPage.vue';
import OfflineTrashPage from './pages/dashboard/OfflineTrashPage.vue';
import OfflineDisabledPage from './pages/OfflineDisabledPage.vue';

// Dashboard Views.
import DashboardLearnerPage from './pages/dashboard/LearnerPage.vue';
import DashboardLearnerRegistrationPage from './pages/dashboard/LearnerRegistrationPage.vue';
import DashboardLearnerRegistrationOverviewPage from './pages/dashboard/LearnerRegistrationOverviewPage.vue';
import DashboardLearnerSimulationPage from './pages/dashboard/LearnerSimulationPage.vue';
import DashboardLearnerSimulationEditPage from './pages/dashboard/LearnerSimulationEditPage.vue';
import DashboardLearnerPrivateReviewPage from './pages/dashboard/LearnerPrivateReviewPage.vue';
import DashboardCohortPage from './pages/dashboard/CohortPage.vue';
import DashboardCohortRegistrationPage from './pages/dashboard/CohortRegistrationPage.vue';
import DashboardCohortSimulationPage from './pages/dashboard/CohortSimulationPage.vue';
import DashboardCohortSimulationCompetenciesPage from './pages/dashboard/CohortSimulationCompetenciesPage.vue';
import DashboardGroupRegistrationPage from './pages/dashboard/GroupRegistrationPage.vue';
import DashboardGroupSimulationPage from './pages/dashboard/GroupSimulationPage.vue';
import DashboardGroupSimulationCompetenciesPage from './pages/dashboard/GroupSimulationCompetenciesPage.vue';

// Global report views.
import ReportsCohortsPage from './pages/reports/CohortsPage.vue';
import ReportsCohortLearnersPage from './pages/reports/CohortLearnersPage.vue';
import ReportsCohortInstructorsPage from './pages/reports/CohortInstructorsPage.vue';
import ReportsCohortDegreesPage from './pages/reports/CohortDegreesPage.vue';
import ReportsCohortRegistrationResultsPage from './pages/reports/CohortRegistrationResultsPage.vue';
import ReportsLearnerRegistrationResultsPage from './pages/reports/LearnerRegistrationResultsPage.vue';

// Log Views.
import LogLogPage from './pages/log/LogPage.vue';
import LogLearnerLogPage from './pages/log/LearnerLogPage.vue';
import LogSessionLogPage from './pages/log/SessionLogPage.vue';
import LogSessionSummaryPage from './pages/log/SessionSummaryPage.vue';
import LogSimulationLogPage from './pages/log/SimulationLogPage.vue';
import LogSimulationSummaryPage from './pages/log/SimulationSummaryPage.vue';
import LogSimulationIssuesPage from './pages/log/SimulationIssuesPage.vue';
import LogRegistrationIssuesPage from './pages/log/RegistrationIssuesPage.vue';

function getRoutes(auth) {

    // Used for local permissions implementation.
    const permissions = Vue.prototype.$permissions

    return [
        
        // Auth pages.
        {
            path: "/astral/ui",
            redirect: "/astral/ui/login",
            component: AuthLayout,
            children: [
                {
                    path: "login",
                    name: "login",
                    beforeEnter: auth.ifNotAuthenticated,
                    component: LoginPage
                },
                {
                    path: "reset-password",
                    name: "forgot-password",
                    beforeEnter: auth.ifNotAuthenticated,
                    component: ForgotPasswordPage
                },
                {
                    path: "reset-password/:token",
                    name: "define-password",
                    beforeEnter: auth.ifNotAuthenticated,
                    component: DefinePasswordPage
                },
            ]
        },

        // Offline pages.
        {
            path: "/astral/ui",
            component: SideMenuLayout,
            children: [
                {
                    path: "offline/dashboard",
                    name: "offline-dashboard",
                    beforeEnter: auth.ifAuthenticated,
                    component: OfflineDashboardPage
                },
                {
                    path: "offline/trash",
                    name: "offline-trash",
                    beforeEnter: auth.ifAuthenticated,
                    component: OfflineTrashPage
                },
                {
                    path: "offline/disabled",
                    name: "offline-disabled",
                    beforeEnter: auth.ifAuthenticated,
                    component: OfflineDisabledPage
                },
            ]
        },

        // Home & profile.
        {
            path: "/astral/ui",
            component: SideMenuLayout,
            children: [
                {
                    path: "home",
                    name: "home",
                    beforeEnter: permissions.redirectToHome,
                    component: HomePage
                },
                {
                    path: "home/dashboard",
                    name: "dashboard-home",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-pilot-dashboard',
                            'dashboard.access-issues-from-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                            'dashboard.access-external-observer-dashboard',
                        ], to, from, next, 'offline-dashboard')
                    },
                    component: DashboardHomePage
                },
                {
                    path: "home/dashboard/learner",
                    name: "dashboard-learner-home",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('dashboard.access-learner-dashboard', to, from, next, 'offline-disabled')
                    },
                    component: DashboardLearnerHomePage
                },
                {
                    path: "home/dashboard/instructor-warnings",
                    name: "dashboard-instructor-warnings",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('dashboard.access-instructor-dashboard', to, from, next, 'home')
                    },
                    component: DashboardInstructorWarningsPage
                },
                {
                    path: "my-account",
                    name: "my-account",
                    beforeEnter: (to, from, next) => {
                        auth.ifAuthenticated(to, from, next, 'home')
                    },
                    component: MyAccountPage
                },
                {
                    path: "change-password",
                    name: "change-password",
                    beforeEnter: (to, from, next) => {
                        auth.ifAuthenticated(to, from, next, 'home')
                    },
                    component: ChangePassword
                },
                {
                    path: "privacy",
                    name: "privacy",
                    beforeEnter: (to, from, next) => {
                        auth.ifAuthenticated(to, from, next, 'home')
                    },
                    component: PrivacyPage
                },
            ]
        },

        // Accounts management.
        {
            path: "/astral/ui/accounts",
            component: SideMenuLayout,
            children: [
                {
                    path: "users",
                    name: "admin-users",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['user.manage', 'user.manage-pilots', 'user.supervise'], to, from, next, 'home')
                    },
                    component: AdminUsersPage
                },
                {
                    path: "users/clear",
                    name: "clear-users",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasAllPermissions(['user.manage', 'admin.delete-personal-data'], to, from, next, 'home')
                    },
                    component: AdminClearUsersPage
                },
                {
                    path: "users/import",
                    name: "import-users",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasAllPermissions(['user.manage'], to, from, next, 'home')
                    },
                    component: AdminImportUsersPage
                },
                {
                    path: "users/:id",
                    name: "admin-user",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission(['user.manage', 'user.manage-pilots', 'user.supervise'], to, from, next, 'home')
                    },
                    component: AdminUserPage
                },
                {
                    path: "cohorts",
                    name: "admin-cohorts",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('cohort.manage', to, from, next, 'home')
                    },
                    component: AdminCohortsPage
                },
                {
                    path: "cohorts/clear",
                    name: "clear-cohorts",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasAllPermissions(['cohort.manage', 'admin.delete-personal-data'], to, from, next, 'home')
                    },
                    component: AdminClearCohortsPage
                },
                {
                    path: "cohorts/import",
                    name: "import-cohorts",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasAllPermissions(['cohort.manage'], to, from, next, 'home')
                    },
                    component: AdminImportCohortsPage
                },
                {
                    path: "cohorts/:id",
                    name: "admin-cohort",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('cohort.manage', to, from, next, 'home')
                    },
                    component: AdminCohortPage
                },
                {
                    path: "cohorts/:id/meta",
                    name: "admin-meta-cohort",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('cohort.manage', to, from, next, 'home')
                    },
                    component: AdminMetaCohortPage
                },
                {
                    path: "roles",
                    name: "admin-roles",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('role.manage', to, from, next, 'home')
                    },
                    component: AdminRolesPage
                },
                {
                    path: "owners",
                    name: "admin-owners",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('owner.manage', to, from, next, 'home')
                    },
                    component: AdminOwnersPage
                },
                {
                    path: "entities",
                    name: "admin-entities",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('entity.manage', to, from, next, 'home')
                    },
                    component: AdminEntitiesPage
                },
            ]
        },

        // Training management.
        {
            path: "/astral/ui/training",
            component: SideMenuLayout,
            children: [
                {
                    path: "competencies",
                    name: "admin-competencies",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('competency.manage', to, from, next, 'home')
                    },
                    component: AdminCompetenciesPage
                },
                {
                    path: "competency-grids",
                    name: "admin-competency-grids",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('grid.manage', to, from, next, 'home')
                    },
                    component: AdminCompetencyGridsPage
                },
                {
                    path: "competency-grids/clear",
                    name: "clear-competency-grids",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasAllPermissions(['grid.manage', 'admin.delete-archived-content'], to, from, next, 'home')
                    },
                    component: AdminClearCompetencyGridsPage
                },
                {
                    path: "competency-grids/:id",
                    name: "admin-competency-grid",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('grid.manage', to, from, next, 'home')
                    },
                    component: AdminGridPage
                },
                {
                    path: "degrees",
                    name: "admin-degrees",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('degree.manage', to, from, next, 'home')
                    },
                    component: AdminDegreesPage
                },
                {
                    path: "degrees/clear",
                    name: "clear-degrees",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasAllPermissions(['degree.manage', 'admin.delete-archived-content'], to, from, next, 'home')
                    },
                    component: AdminClearDegreesPage
                },
                {
                    path: "degrees/:id",
                    name: "admin-degree",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('degree.manage', to, from, next, 'home')
                    },
                    component: AdminDegreePage
                },
                {
                    path: "degrees/:degreeId/simulations/:simulationId",
                    name: "admin-log",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('degree.manage', to, from, next, 'home')
                    },
                    component: AdminLogPage
                },
                {
                    path: "registrations",
                    name: "admin-registrations",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('registration.manage', to, from, next, 'home')
                    },
                    component: AdminRegistrationsPage
                },
                {
                    path: "registrations/clear",
                    name: "clear-registrations",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasAllPermissions(['registration.manage', 'admin.delete-personal-data'], to, from, next, 'home')
                    },
                    component: AdminClearRegistrationsPage
                },
            ]
        },

        // Reports.
        {
            path: "/astral/ui/reports",
            component: SideMenuLayout,
            children: [
                {
                    path: "cohorts",
                    name: "report-cohorts",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('dashboard.access-global-reports', to, from, next, 'home')
                    },
                    component: ReportsCohortsPage
                },
                {
                    path: "cohorts/:cohortId/degrees",
                    name: "report-cohort-degrees",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('dashboard.access-global-reports', to, from, next, 'home')
                    },
                    component: ReportsCohortDegreesPage
                },
                {
                    path: "cohorts/:cohortId/learners",
                    name: "report-cohort-learners",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('dashboard.access-global-reports', to, from, next, 'home')
                    },
                    component: ReportsCohortLearnersPage
                },
                {
                    path: "cohorts/:cohortId/instructors",
                    name: "report-cohort-instructors",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('dashboard.access-global-reports', to, from, next, 'home')
                    },
                    component: ReportsCohortInstructorsPage
                },
                {
                    path: "registrations/:registrationId/cohorts/:cohortId/results",
                    name: "report-cohort-registration-results",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('dashboard.access-global-reports', to, from, next, 'home')
                    },
                    component: ReportsCohortRegistrationResultsPage
                },
                {
                    path: "registrations/:registrationId/learners/:learnerId/results",
                    name: "report-learner-registration-results",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('dashboard.access-global-reports', to, from, next, 'home')
                    },
                    component: ReportsLearnerRegistrationResultsPage
                },
            ]
        },

        // Settings.
        {
            path: "/astral/ui/settings",
            component: SideMenuLayout,
            children: [
                {
                    path: "socrates-export",
                    name: "socrates-export",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('admin', to, from, next, 'home')
                    },
                    component: AdminSocratesExportPage
                },
            ]
        },

        // Dashboard.
        {
            path: "/astral/ui/dashboard",
            component: SideMenuLayout,
            children: [
                {
                    path: "learners/:learnerId",
                    name: "dashboard-learner",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                            'dashboard.access-external-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardLearnerPage
                },
                {
                    path: "registrations/:registrationId/learners/:learnerId",
                    name: "dashboard-learner-registration",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-learner-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardLearnerRegistrationPage
                },
                {
                    path: "registrations/:registrationId/learners/:learnerId/overview",
                    name: "dashboard-learner-registration-overview",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-learner-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                            'dashboard.access-external-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardLearnerRegistrationOverviewPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/learners/:learnerId",
                    name: "dashboard-learner-simulation",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-learner-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardLearnerSimulationPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/learners/:learnerId/edit",
                    name: "dashboard-learner-simulation-edit",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('dashboard.access-instructor-dashboard', to, from, next, 'home')
                    },
                    component: DashboardLearnerSimulationEditPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/learners/:learnerId/private-review-report",
                    name: "dashboard-learner-private-review-report",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasPermission('dashboard.access-instructor-dashboard', to, from, next, 'home')
                    },
                    component: DashboardLearnerPrivateReviewPage
                },
                {
                    path: "cohorts/:cohortId",
                    name: "dashboard-cohort",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-pilot-dashboard',
                            'dashboard.access-issues-from-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardCohortPage
                },
                {
                    path: "registrations/:registrationId/cohorts/:cohortId",
                    name: "dashboard-cohort-registration",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-pilot-dashboard',
                            'dashboard.access-issues-from-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardCohortRegistrationPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/cohorts/:cohortId",
                    name: "dashboard-cohort-simulation",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardCohortSimulationPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/cohorts/:cohortId/competencies",
                    name: "dashboard-cohort-simulation-competencies",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardCohortSimulationCompetenciesPage
                },
                {
                    path: "registrations/:registrationId/groups/:groupId",
                    name: "dashboard-group-registration",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardGroupRegistrationPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/groups/:groupId",
                    name: "dashboard-group-simulation",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardGroupSimulationPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/groups/:groupId/competencies",
                    name: "dashboard-group-simulation-competencies",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: DashboardGroupSimulationCompetenciesPage
                },
            ]
        },

        // Log.
        {
            path: "/astral/ui/log",
            component: SideMenuLayout,
            children: [
                {
                    path: "registrations/:registrationId/simulations/:simulationId/groups/:groupId",
                    name: "log",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                            'dashboard.access-issues-from-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: LogLogPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/learners/:learnerId",
                    name: "log-learner",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                            'dashboard.access-restricted-internal-observer-dashboard',
                            'dashboard.access-internal-observer-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: LogLearnerLogPage
                },
                {
                    // There is no offline redirection here because we want to be able to access to the offline log.
                    // In the page, the 444 error is checked and it redirects to the offline dashboard.
                    path: "registrations/:registrationId/simulations/:simulationId/sessions/:sessionId/groups/:groupId/log",
                    name: "log-session",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                        ], to, from, next)
                    },
                    component: LogSessionLogPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/sessions/:sessionId/groups/:groupId/summary",
                    name: "log-session-summary",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-instructor-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: LogSessionSummaryPage
                },
                {
                    // There is no offline redirection here because we want to be able to access to the offline log.
                    // In the page, the 444 error is checked and it redirects to the offline dashboard.
                    path: "registrations/:registrationId/simulations/:simulationId/groups/:groupId/log",
                    name: "log-simulation-log",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-pilot-dashboard',
                        ], to, from, next)
                    },
                    component: LogSimulationLogPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/groups/:groupId/summary",
                    name: "log-simulation-summary",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-pilot-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: LogSimulationSummaryPage
                },
                {
                    path: "registrations/:registrationId/simulations/:simulationId/groups/:groupId/issues",
                    name: "log-simulation-issues",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-issues-from-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: LogSimulationIssuesPage
                },
                {
                    path: "registrations/:registrationId/groups/:groupId/issues",
                    name: "log-registration-issues",
                    beforeEnter: (to, from, next) => {
                        auth.ifHasOnePermission([
                            'dashboard.access-issues-from-dashboard',
                        ], to, from, next, 'home')
                    },
                    component: LogRegistrationIssuesPage
                },
            ]
        },

        // Special pages.
        {
            path: "/astral/ui",
            component: FullPageLayout,
            children: [
                {
                    path: "unauthorized",
                    name: "unauthorized",
                    component: UnauthorizedPage,
                },
                {
                    path: "maintenance",
                    name: "maintenance",
                    component: MaintenancePage,
                },
                {
                    path: "error",
                    name: "error",
                    component: ErrorPage,
                },
                {
                    path: "*",
                    name: "unknown",
                    component: NotFoundPage,
                },
            ]
        },
    ]
}

export default {

    routes() {
        return getRoutes(Vue.prototype.$auth)
    },

    router() {
        return RouterFactory.make(this.routes(), 'nav-item active')
    },
}

